export default {
  "content": "<path d=\"M11.387 12.238a3.365 3.365 0 00-2.375-.988 3.365 3.365 0 00-2.398.988M15.75 9a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0zM7.312 7.312c0 .311-.125.563-.28.563-.156 0-.282-.252-.282-.563 0-.31.126-.562.281-.562.156 0 .282.252.282.563zm-.28 0h.005v.012H7.03v-.011zm4.218 0c0 .311-.126.563-.281.563-.156 0-.281-.252-.281-.563 0-.31.125-.562.28-.562.156 0 .282.252.282.563zm-.281 0h.005v.012h-.005v-.011z\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "18",
    "height": "18",
    "viewBox": "0 0 18 18",
    "fill": "none"
  }
};